export default "__VITE_ASSET__B85RG6Vl__"